// Import custom components
import Home from "../views/home";
import Login from "../views/login";
import Layout from "../views/layout";
import NotFound from "../views/common/not_found";
import CustomerDetails from "../views/customers/details";
import Customers from "../views/customers";
import Migration from "../views/migration";
import CreateMigration from "../views/migration/create-migration"
import MigrationStatus from "../views/migration/create-migration/components/migration_status_template"
import CreateCustomer from "../views/customers/create-customer";
import Coworkers from "../views/coworkers";
import CoWorkerDetails from "../views/coworkers/details";
import Settings from "../views/settings/";
import { ADMIN, CS, SUPERADMIN, FINANCEADMIN, PARTNER} from "../constants/roles";
import Apps from "../views/apps";
import Onboarding from "../views/onboarding";

const routingObject = [
  {
    element: <Layout />,
    name: "",
    icon: "",
    errorElement: <Layout />,
    layout: "admin",
    children: [
      {
        path: "/",
        role: ["*"],
        element: <Home />,
      },
      {
        path: "/customers",
        role: ["*"],
        element: <Customers />,
        isPrivate: true,
      },
      {
        path: "/migration",
        role: ["*"],
        element: <Migration />,
        isPrivate: true,
      },
      {
        path: "/migration/create",
        role: [SUPERADMIN, ADMIN, FINANCEADMIN, PARTNER],
        element: <CreateMigration />,
        isPrivate: true,
      },
      {
        path: "/migration/:migration_uid/:currentModule",
        role: [SUPERADMIN, ADMIN, FINANCEADMIN, PARTNER],
        element: <CreateMigration />,
        isPrivate: true,
      },
      {
        path: "/customers/create",
        role: [SUPERADMIN, ADMIN, FINANCEADMIN, PARTNER],
        element: <CreateCustomer />,
        isPrivate: true,
      },
      {
        path: "/customers/:company_uid",
        role: ["*"],
        children: [
          {
            path: ":type",
            element: <CustomerDetails />,
          }
        ],
        isPrivate: true,
      },
      {
        path: "/coworkers",
        role: [ADMIN, SUPERADMIN, FINANCEADMIN],
        element: <Coworkers />,
        isPrivate: true,
      },
      {
        path: "/coworkers/:coworker_uid",
        role: [ADMIN, SUPERADMIN, FINANCEADMIN],
        children: [
          {
            path: ":type",
            element: <CoWorkerDetails />,
          }
        ],
        isPrivate: true,
      },
      {
        path: "/home",
        role: ["*"],
        element: <Home />,
        isPrivate: true,
      },
      {
        path: "/settings",
        role: ["*"],
        element: <Settings />,
        isPrivate: true,
      },
      {
        path: "/apps",
        role: ["*"],
        element: <Apps />,
        isPrivate: true,
      },
    ],
  },
  {
    element: <Login />,
    path: "/login",
    role: ["*"],
  },
  {
    element: <Onboarding />,
    path: "/reset-partner-password/:token",
    role: ["*"],
  },
  {
    element: <NotFound />,
    path: "*",
    role: ["*"],
  },
];

export default routingObject;
